import React from "react"
import LoadingIcon from "images/loading-spinner.svg"
import styles from "./styles.module.scss"

interface Props {
  loadingFlag: boolean
}
/**
 * ローディング画面
 * @param {boolean} loadingFlag - 表示・非表示
 */
const Loading = ({ loadingFlag }: Props) => {
  return (
    <>
      {loadingFlag && (
        <div className={styles.root}>
          <div className={styles.loader}>
            <img src={LoadingIcon} alt="loading" />
            <p className={styles.text}>情報を取得しています...</p>
          </div>
        </div>
      )}
    </>
  )
}

export default Loading
